module.exports = __webpack_public_path__ + "img/Icon material-dashboard.004cd810.svg";